import client from './oc2api';

export type InterestedCompany = {
  id: number;
  name: string;
  square_logo: string | null;
  business_category_name: string;
  overall_score: string | null;
  following: boolean;
};

export function fetchInterestedCompanies(companyId: number): Promise<InterestedCompany[]> {
  return client
    .get(`/api/v1/companies/${companyId}/interested_companies`)
    .then((response) => response.data as InterestedCompany[])
    .catch((error) => {
      console.error('[InterestedCompanies] Failed to fetch:', error);
      return [];
    });
}
